import React, {FC, useRef} from 'react';
import {
  TrackInstallBannerProps,
  TrackedInstallBanner as TrackedInstallBannerEager,
} from './TrackedInstallBanner.eager';
import {useIsBannerOpen} from './useIsBannerOpen';

export const TrackedInstallBanner: FC<TrackInstallBannerProps> = ({
  ...props
}) => {
  const {isOpen} = useIsBannerOpen();
  const hasBeenOpenedRef = useRef(false);

  // we always want to render it on the server
  if (isOpen || !process.browser) {
    hasBeenOpenedRef.current = true;
  }

  /*
   * The AppInstallBanner needs to stay in the DOM and NOT be removed when closing so the closing animation can be played.
   * Afterwards it will be hidden by CSS.
   *
   * So we never unmount the AppInstallBanner after it has been mounted.
   */
  return hasBeenOpenedRef.current ? (
    <TrackedInstallBannerEager {...props} />
  ) : null;
};
